export default {
    data() {
        return {
            trans: {
                en: {
                    requestFailure : 'Request Failure',
                    modalLang: {
                        cancel : 'Cancel',
                        submit : 'Submit',
                        confirm : 'Confirm',
                        create : 'Create',
                    },
                    selectionLang : {
                        search: 'Search filter',
                        selected: 'Selected',
                        placeholder: '- Please select -',
                        select_all: 'Select All',
                        all_levels: 'All Levels'
                    },
                    datetimeLang : {
                        allDay : 'All Day',
                        school_day : 'School Day',
                        start : 'Start',
                        end : 'End',
                        en_title : 'Title (Eng)',
                        other_title : 'Title (Chi)',
                        location : 'Location',
                        type : 'Type',
                        day_type : 'Day Type',
                        section : 'Section',
                        level : 'Level',
                        academic_class : 'Class',
                        customColor : 'Custom Color',
                        color : 'Color',
                        textColor : 'Text Color',
                        en_description : 'Description (Eng)',
                        other_description : 'Description (Chi)',
                        no_event_message : 'No event at this moment',
                        no_record_message: 'No record at this moment',
                        assign_to: 'Assign to',
                        buttonText : {
                            today:    'Today',
                            month:    'Month',
                            week:     'Week',
                            day:      'Day',
                            list:     'List',
                        },
                        allDayText : 'All Day',
                        confirm: 'Confirm',
                        submit : 'Submit',
                        delete : 'Delete',
                        cancel : 'Cancel',
                        children_name: 'Children Name',
                        non_chinese_speaking: 'Non Chinese Speaking',
                        multiple_dates: 'Multiple Dates',
                        select_dates: 'Select Dates',
                        select_multiple_dates: 'Select multiple dates',
                        start_time: 'Start Time',
                        end_time: 'End Time',
                        please_select_dates: 'Please select at least one date',
                        max_30_dates: 'Maximum 30 dates can be selected',
                        duplicate_dates: 'Duplicate dates detected, please remove duplicates',
                        please_select_time: 'Please select start time and end time',
                        start_cannot_be_later_than_end: 'Start time cannot be later than end time',
                        created: ':count created',
                        failure: 'Failed',
                    },
                    Uploader: {
                        upload : 'Upload',
                        cancel : 'Cancel',
                        file : 'File(s)',
                        choose_file : 'Choose File(s)',
                        file_name: 'File Name',
                        file_size: 'File Size',
                        file_size_exceed: 'File Size Exceed',
                        max_file_size: 'Max file size : 100MB',
                    },
                },
                'zh-HK': {
                    requestFailure : '無效的請求',
                    modalLang: {
                        cancel : '取消',
                        submit : '提交',
                        confirm : '確定',
                        create : '新增',
                    },
                    selectionLang : {
                        search: '搜尋過濾項目',
                        selected: '已選擇',
                        placeholder: '- 請選擇 -',
                        select_all: '全選',
                        all_levels: '所有年級'
                    },
                    datetimeLang : {
                        allDay : '全日',
                        school_day : '上學日',
                        start : '開始日期',
                        end : '結束日期',
                        en_title : '標題(英文)',
                        other_title : '標題(中文)',
                        location : '地點',
                        type : '類型',
                        day_type : '學制',
                        section : '學制',
                        level: '年級',
                        academic_class : '班別',
                        color : '顏色',
                        customColor : '自訂顏色',
                        textColor : '文字顏色',
                        en_description : '詳情(英文)',
                        other_description : '詳情(中文)',
                        no_event_message : '暫時沒有活動事項',
                        no_record_message: '暫沒任何紀錄',
                        assign_to: '指定於',
                        buttonText : {
                            today:    '今天',
                            month:    '月',
                            week:     '週',
                            day:      '日',
                            list:     '列表',
                        },
                        allDayText : '全日',
                        confirm : '確定',
                        submit : '提交',
                        delete : '移除',
                        cancel : '取消',
                        children_name: '子女姓名',
                        non_chinese_speaking: '非華語',
                        multiple_dates: '多個日期',
                        select_dates: '選擇日期',
                        select_multiple_dates: '選擇多個日期',
                        start_time: '開始時間',
                        end_time: '結束時間',
                        please_select_dates: '請選擇至少一個日期',
                        max_30_dates: '最多只能選擇30個日期',
                        duplicate_dates: '檢測到重複日期，請移除重複項目',
                        please_select_time: '請選擇開始時間和結束時間',
                        start_cannot_be_later_than_end: '開始時間不能遲於結束時間',
                        created: '已建立 :count 個事項',
                        failure: '失敗',
                    },
                    Uploader: {
                        upload : '上傳',
                        cancel : '取消',
                        file : '檔案',
                        choose_file : '選擇檔案',
                        file_name: '檔案名稱',
                        file_size: '檔案大小',
                        file_size_exceed: '檔案大小超出上限',
                        max_file_size: '檔案總大小上限 : 100MB',
                    },
                },
                dev: {
                    requestFailure : 'trans.requestFailure',
                    modalLang: {
                        cancel : 'Filter.vue.lang.cancel',
                        submit : 'Filter.vue.lang.submit',
                        create : 'Filter.vue.lang.create',
                    },
                    selectionLang : {
                        search: 'Filter.vue.lang.search',
                        selected: 'Filter.vue.lang.selected',
                        placeholder: 'Filter.vue.lang.placeholder',
                        select_all: 'Filter.vue.lang.select_all',
                    },
                    datetimeLang : {
                        allDay : 'Filter.vue.lang.allDay',
                        school_day : 'Filter.vue.lang.school_day',
                        start : 'Filter.vue.lang.start',
                        end : 'Filter.vue.lang.end',
                        en_title : 'Filter.vue.lang.en_title',
                        other_title : 'Filter.vue.lang.other_title',
                        location : 'Filter.vue.lang.location',
                        type : 'Filter.vue.lang.type',
                        day_type : 'Filter.vue.lang.day_type',
                        section : 'Filter.vue.lang.section',
                        level : 'Filter.vue.lang.level',
                        customColor : 'Filter.vue.lang.customColor',
                        color : 'Filter.vue.lang.color',
                        textColor : 'Filter.vue.lang.textColor',
                        en_description : 'Filter.vue.lang.en_description',
                        other_description : 'Filter.vue.lang.other_description',
                        no_event_message : 'Filter.vue.lang.no_event_message',
                        no_record_message: 'Filter.vue.lang.no_record_message',
                        assign_to: 'Filter.vue.lang.assign_to',
                        buttonText : {
                            today:    'Filter.vue.lang.today',
                            month:    'Filter.vue.lang.month',
                            week:     'Filter.vue.lang.week',
                            day:      'Filter.vue.lang.day',
                            list:     'Filter.vue.lang.list',
                        },
                        allDayText : 'Filter.vue.lang.allDayText',
                        confirm: 'Filter.vue.lang.confirm',
                        submit : 'Filter.vue.lang.submit',
                        delete : 'Filter.vue.lang.delete',
                        cancel : 'Filter.vue.lang.cancel',
                        children_name: 'Filter.vue.lang.children_name',
                        non_chinese_speaking: 'Filter.vue.lang.non_chinese_speaking',
                        multiple_dates: 'Filter.vue.lang.multiple_dates',
                        select_dates: 'Filter.vue.lang.select_dates',
                        select_multiple_dates: 'Filter.vue.lang.select_multiple_dates',
                        start_time: 'Filter.vue.lang.start_time',
                        end_time: 'Filter.vue.lang.end_time',
                        please_select_dates: 'Filter.vue.lang.please_select_dates',
                        max_30_dates: 'Filter.vue.lang.max_30_dates',
                        duplicate_dates: 'Filter.vue.lang.duplicate_dates',
                        please_select_time: 'Filter.vue.lang.please_select_time',
                        start_cannot_be_later_than_end: 'trans.datetimeLang.start_cannot_be_later_than_end',
                        created: 'trans.datetimeLang.created',
                        failure: 'trans.datetimeLang.failure',
                    },
                    Uploader: {
                        upload : 'Filter.vue.lang.upload',
                        cancel : 'Filter.vue.lang.cancel',
                        file : 'Filter.vue.lang.file',
                        choose_file : 'Filter.vue.lang.choose_file',
                        file_name: 'Filter.vue.lang.file_name',
                        file_size: 'Filter.vue.lang.file_size',
                        file_size_exceed: 'Filter.vue.lang.file_size_exceed',
                        max_file_size: 'Filter.vue.lang.max_file_size',
                    },
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/trans.js